import { render, staticRenderFns } from "./FeaturedBadge.vue?vue&type=template&id=142754c2&scoped=true&"
import script from "./FeaturedBadge.vue?vue&type=script&lang=js&"
export * from "./FeaturedBadge.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedBadge.vue?vue&type=style&index=0&id=142754c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142754c2",
  null
  
)

export default component.exports